import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";
import {
  SYLLABUS_ALL_ACTIONS_TYPE,
  STUDENT_STATUS_FILTER_ACTION_TYPE,
} from "../../../redux/actions-type";
import { useLocation } from "react-router-dom";
import { getConsultationStatistics } from "../../../redux/actions/reportActions";
import { getAllWhereComing } from "../../../redux/actions/whereHeardActions";
import moment from "moment";

export const WhereComingDropdown = ({
  deviceType = "",
  selectedOption,
  date,
  selectedDateType,
}) => {
  const dispatch = useDispatch();
  const { whereHeardData: dataList } = useSelector((state) => state.whereHeard);

  const { selectedWhereComing } = useSelector((state) => state.syllabusCourse);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { courseId } = useSelector((state) => state.studentStatus);

  const location = useLocation();

  const dropdownRef = useRef(null);

  const start = moment(date.startDate).format("YYYY-MM-DD");
  const end = moment(date.endDate).format("YYYY-MM-DD");

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch({
        type: SYLLABUS_ALL_ACTIONS_TYPE.CLEAR_WHERE_COMING,
      });

      dispatch({
        type: STUDENT_STATUS_FILTER_ACTION_TYPE.CLEAR_WHERE_COMINGID,
      });
    };
  }, [dispatch]);

  const handleAllCourse = () => {
    dispatch({
      type: STUDENT_STATUS_FILTER_ACTION_TYPE.GET_WHERE_COMINGID,
      payload: "",
    });

    dispatch(
      getConsultationStatistics(
        selectedOption ? "" : start,
        selectedOption ? "" : end,
        selectedOption,
        courseId,
        "",
        selectedDateType.key || ""
      )
    );

    setDropdownOpen(false);
  };

  useEffect(() => {
    dispatch(getAllWhereComing());
  }, [dispatch]);

  const handleChangeDrop = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const getWereComing = (whereComing) => {
    dispatch({
      type: SYLLABUS_ALL_ACTIONS_TYPE.SELECT_WHERE_COMING,
      payload: whereComing,
    });

    dispatch({
      type: SYLLABUS_ALL_ACTIONS_TYPE.RESET_SYLLABUS_PAGINATION,
    });

    dispatch(
      getConsultationStatistics(
        selectedOption ? "" : start,
        selectedOption ? "" : end,
        selectedOption,
        courseId || "",
        whereComing._id,

        selectedDateType.key || ""
      )
    );
  };

  const handleOneWhereComing = (id) => {
    dispatch({
      type: STUDENT_STATUS_FILTER_ACTION_TYPE.GET_WHERE_COMINGID,
      payload: id,
    });
    setDropdownOpen(false);
  };

  return (
    <div
      ref={dropdownRef}
      className={`global-category-dropdown dropdown-name data-status ${deviceType} ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div className="dropdown-head" onClick={handleChangeDrop}>
        {!["/tuition-fee", "/tuitionFee"].includes(location.pathname) ? (
          <h2>{selectedWhereComing ? selectedWhereComing.name : "Mənbə"}</h2>
        ) : (
          <h2>Haradan gəliblər </h2>
        )}

        <div className="arrow-icon">
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          <li onClick={handleAllCourse}>Hamısı</li>
          {dataList?.map((item) => (
            <li
              key={item._id}
              onClick={() => {
                handleOneWhereComing(item._id);
                getWereComing(item);
              }}
            >
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
